import React from 'react';
import AreaOverview from '../AreaOverview/AreaOverview';

function VirtualMatrixTab({ area, device, onDeviceSelect, onOpenDeviceRemote, onOpenAndroidPowerSettings, onTopologyChange }) {
  return (
    <AreaOverview
      area={area}
      currentDeviceId={device?.id || null}
      onDeviceSelect={onDeviceSelect}
      onOpenDeviceRemote={onOpenDeviceRemote}
      onOpenAndroidPowerSettings={onOpenAndroidPowerSettings}
      onTopologyChange={onTopologyChange}
      mode="virtual-matrix"
    />
  );
}

export default VirtualMatrixTab;
